export default "__VITE_ASSET__a08d785e__"